import React from "react"
import Navigation from "../navigation"
import styles from "./header.module.css"
import header from "./header_background.png"
import headerMobile from "./header_background_mobile.png"
const Header = (props) => {

    return (
        <div className={styles.container}>
            {props.navigation}
            <img src={header} alt="2020 San Francisco CyberTalks" className="deskHead" width="100%"/>
            <img src={headerMobile} alt="2020 San Francisco CyberTalks" className="mobHead" width="100%"/>
            <div className={styles.hideme}>
                <h1 className={styles.title}>{props.title}</h1>
                <h1 className={styles.subTitle}>{props.subTitle}</h1>
                <div style={{paddingLeft:10}}>register</div>
            </div>
        </div>
    )
}

Header.defaultProps = {
    title: `IT MOD`,
    subTitle: `2020`
}
export default Header